import { VehicleSettingType } from '@/utils/enum';
import { CommonResponse } from '@/utils/types';
import { request } from '../core';
import BaseOptions from './base';

export interface StationVehicleItem {
  vehicleName: string;
  vehicleTypeId: number;
  vehicleTypeName: string;
}

class MultiVehicleApi extends BaseOptions {
  public getVehicleList(): Promise<any> {
    const requestOptions: RequestOptions = {
      absoluteURL:
        this.fetchDomain + '/schedule/generalTransport/getVehicleList',
      method: 'POST',
      headers: this.requestHeaders
    };

    return request(requestOptions);
  }
  public getVehicleSetting(): Promise<any> {
    const requestOptions: RequestOptions = {
      absoluteURL:
        this.fetchDomain + '/schedule/generalTransport/getNotifyConfig',
      method: 'POST',
      headers: this.requestHeaders
    };
    return request(requestOptions);
  }
  public updateVehicleSetting(data: {
    opened: 1 | 0;
    type: VehicleSettingType;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/generalTransport/notifyConfig',
      method: 'POST',
      headers: this.requestHeaders,
      body: data
    };
    return request(requestOptions);
  }
  public getVehicleBusinessType(vehicleName: string): Promise<any> {
    const requestOptions: RequestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/h5/getVehicleBusinessData',
      method: 'POST',
      headers: this.requestHeaders,
      body: { vehicleName }
    };
    return request(requestOptions);
  }

  public getStationVehicleList(
    stationNumber: string
  ): Promise<CommonResponse<StationVehicleItem[]>> {
    const requestOptions: RequestOptions = {
      absoluteURL:
        this.fetchDomain + '/k2/management/mobile/get_station_vehicle_list',
      method: 'POST',
      headers: this.requestHeaders,
      body: { stationNumber }
    };
    return request(requestOptions);
  }
}

export default MultiVehicleApi;
